import { render, staticRenderFns } from "./ModalSubmitButton.vue?vue&type=template&id=6aae9bed&scoped=true&"
import script from "./ModalSubmitButton.vue?vue&type=script&lang=ts&"
export * from "./ModalSubmitButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae9bed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aae9bed')) {
      api.createRecord('6aae9bed', component.options)
    } else {
      api.reload('6aae9bed', component.options)
    }
    module.hot.accept("./ModalSubmitButton.vue?vue&type=template&id=6aae9bed&scoped=true&", function () {
      api.rerender('6aae9bed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/SearchBar/view/vue/ModalSubmitButton.vue"
export default component.exports